import { EventEmitter, Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject, Observable, tap } from 'rxjs';

export type BreakpointState = 'Handset' | 'Web' | 'HandsetPortrait' | 'WebPortrait' | 'HandsetLandscape' | 'WebLandscape' ;

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {

  public isHandset = false;
  public portrait$: EventEmitter<any>;
  public landscape$: EventEmitter<any>;
  public handset$: BehaviorSubject<boolean>;
  private _breakpoint$: BehaviorSubject<BreakpointState>;

  constructor(private breakpointObserver: BreakpointObserver) {
    this._breakpoint$ = new BehaviorSubject<BreakpointState>('Web');
    this.portrait$ = new EventEmitter();
    this.landscape$ = new EventEmitter();
    this.handset$ = new BehaviorSubject<any>(false);

    this.initBreakpointObserver();
  }

  get breakpoint$(): Observable<BreakpointState> {
    return this._breakpoint$.asObservable();
  }

  private initBreakpointObserver(): void {
    this.breakpointObserver
      .observe([
        Breakpoints.Handset,
        Breakpoints.Tablet
      ])
      .subscribe(result => {
        if(result.matches) {
          // if (result.breakpoints[Breakpoints.HandsetPortrait] ||
          //    result.breakpoints[Breakpoints.HandsetLandscape] ||
          //    result.breakpoints[Breakpoints.TabletPortrait] ||
          //    result.breakpoints[Breakpoints.TabletLandscape]
          //    ) {
            this.handset$.next(true);
        } else {
          this.handset$.next(false);
        }
      }
      );

      this.breakpointObserver
      .observe([
        Breakpoints.HandsetPortrait,
        Breakpoints.TabletPortrait,
      ])
        .subscribe(result => {
          if(result.matches) {
          if(result.breakpoints[Breakpoints.HandsetPortrait]) {
            this.portrait$.next('HandsetPortrait');
          } else if (result.breakpoints[Breakpoints.TabletPortrait]) {
            this.portrait$.next('TabletPortrait');
          }
        }
      });

      this.breakpointObserver
      .observe([
        Breakpoints.HandsetLandscape,
        Breakpoints.TabletLandscape,
      ])
        .subscribe(result => {
          if(result.matches) {
          if(result.breakpoints[Breakpoints.HandsetLandscape]) {
            this.landscape$.next('HandsetLandscape');
          } else if (result.breakpoints[Breakpoints.TabletLandscape]) {
            this.landscape$.next('TabletLandscape');
          }
        }
      });

  }
}

